window.addEventListener('click', (event)=>{
    let target;
    /* ajax zahájení/ukončení práce z domu */
    if (target = event.target.closest('#js-container-dochazka-pd-menu .ajax[href], #js-container-dochazka-pd-menu .ajax2[href]')) {
        event.preventDefault();
        event.stopPropagation();
        var ajax = new window.VutRequiredLib.Ajax(target.href, "GET");
        vutAjax._doAjax(ajax, {preloader_parent:target.closest('#js-container-dochazka-pd-menu'),})
            .then(()=>localStorage.setItem("last-dochazka-menu-"+window.gl_perid, document.querySelector("#js-container-dochazka-pd-menu").innerHTML.replace(/\s+/g, " ")));
        return false;
    }
    // ajax načtení "správného" tlačítka //
    if (target=event.target.closest('#dropdown-user')) {

        // timeout, aby se
        let item = target.parentNode.querySelector('#js-container-dochazka-pd-menu');

        if (item) {
            item.innerHTML = localStorage.getItem("last-dochazka-menu-" + window.gl_perid);

            setTimeout(() => {
// timeout, aby se -- po rozbalení dropdownu -- správně poznalo, jestli je rozbalenej, nebo schovanej... nemá smysl načítat ajax, když je to schované... //
                if (item?.offsetParent) {
                    item.innerHTML = localStorage.getItem("last-dochazka-menu-" + window.gl_perid);
                    if (window.gl_debug) console.log("načítám práci z domu...");
                    var ajax = new window.VutRequiredLib.Ajax(window.gl_url_www + window.jstr('', 'en/') + 'intra/' + window.jstr('dochazka', 'attendance') + '/osoba/' + window.gl_perid + '/get-menu', "GET");
                    vutAjax._doAjax(ajax, {preloader_parent: item})
                        .then(() => localStorage.setItem("last-dochazka-menu-" + window.gl_perid, document.querySelector("#js-container-dochazka-pd-menu").innerHTML.replace(/\s+/g, " ")));
                }

            }, 10);
        }
    }
}, true);